import { Outlet } from "@tanstack/react-router";

import { useUserInfos } from "@onesolution/hooks";
import posthog from "posthog-js";
import Sidebar from "./Sidebar/Sidebar";

export default function AppLayout() {
	const user = useUserInfos();

	if (!posthog._isIdentified()) {
		posthog.identify(user.email, {
			keycloak_id: user.sub,
			workspace_id: user.monday_workspace_id,
		});
	}

	return (
		<div className="flex h-dvh w-full p-4 gap-4">
			<Sidebar />

			<main className="size-full pt-6 px-4 flex flex-col overflow-hidden">
				<Outlet />
			</main>
		</div>
	);
}
